import React from "react";
import { getReport } from "../../../../graphql/queries";
import PropTypes from "prop-types";
import * as DataTypes from "../../../../constants/Data/DataTypes";
import GeneralInfo from "../../../Common/GeneralInfo";

const PostReportGeneralInfo = (props) => {
  return (
    <GeneralInfo
      modelId={props.postReportId}
      modelName={"Report"}
      listOfProperties={[
        {
          key: 1,
          attributeName: "reportByUserName",
          attributeTitle: "Reported By",
          description: "Reported By UserName",
          dataType: DataTypes.String,
        },
        {
          key: 2,
          attributeFetchFunction: (data) => {
            return data.reportCategory.name;
          },
          attributeTitle: "Report Category",
          description: "Report Category",
          dataType: DataTypes.String,
        },
        {
          key: 3,
          attributeName: "message",
          attributeTitle: "Report Message",
          description: "Report Message",
          dataType: DataTypes.String,
        },
        {
          key: 4,
          attributeName: "reportPostUserName",
          attributeTitle: "Reported",
          description: "Reported Post owner UserName",
          dataType: DataTypes.String,
        },
        {
          key: 5,
          attributeName: "reportPostId",
          attributeTitle: "Reported Post",
          description: "Reported Post Id",
          dataType: DataTypes.String,
        },
        {
          key: 6,
          attributeName: "createdAt",
          attributeTitle: "Created At",
          description: "Report Created At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 7,
          attributeName: "updatedAt",
          attributeTitle: "Updated At",
          description: "Report Updated At",
          dataType: DataTypes.DateTime,
        },
        {
          key: 8,
          attributeName: "deletedAt",
          attributeTitle: "Deleted At",
          description: "Report Deleted At",
          dataType: DataTypes.DateTime,
        },
      ]}
      providedModelData={props.providedModelData}
      queryFunction={getReport}
      queryFunctionName={"getReport"}
    />
  );
};

PostReportGeneralInfo.propTypes = {
  postReportId: PropTypes.string.isRequired,
  providedModelData: PropTypes.object,
};

PostReportGeneralInfo.defaultProps = {
  providedModelData: null,
};

export default PostReportGeneralInfo;
